import { AuthService } from './services/auth.js';
import { renderLayout, initLayoutEvents } from './components/layout.js';
import { renderDashboardView, initDashboardEvents, destroyCharts } from './views/dashboard.js';
import { renderProjectsView, initProjectsEvents } from './views/projects.js';
import { renderPipelineView, initPipelineEvents } from './views/pipeline.js';
import { renderRatesView, initRatesEvents } from './views/rates.js';
import { renderFinanceView, initFinanceEvents } from './views/finance.js';
import { renderKnowledgeView, initKnowledgeEvents } from './views/knowledge.js';
import { renderSettingsView, initSettingsEvents } from './views/settings.js';
import { renderLoginView, initLoginEvents } from './views/login.js';
import { renderEmailMarketingView, initEmailMarketingEvents } from './views/email_marketing.js';
import { renderResourcesView, initResourcesEvents } from './views/resources.js';

export async function navigate() {
  // Safety: ensure any orphan modal lock is cleared on navigation so scrollbars never disappear
  document.body.classList.remove('overflow-hidden');
  window.scrollTo(0, 0);

  // Clean up any Chart.js instances before navigating/re-rendering
  destroyCharts();

  const app = document.getElementById('app');
  if (!app) return;

  const rawHash = window.location.hash || '#/dashboard';
  const route = rawHash.replace('#/', '').split('?')[0] || 'dashboard';

  // Check auth
  const session = await AuthService.getSession();

  // If not logged in and not on login page, redirect to login
  if (!session && route !== 'login') {
    window.location.hash = '#/login';
    return;
  }

  // If logged in and on login page, redirect to dashboard
  if (session && route === 'login') {
    window.location.hash = '#/dashboard';
    return;
  }

  if (route === 'login') {
    app.innerHTML = renderLoginView();
    initLoginEvents();
    return;
  }

  // Render view inside Layout shell
  let content = '';
  let initViewEvents = () => {};

  try {
    switch (route) {
      case 'dashboard':
        content = await renderDashboardView();
        initViewEvents = initDashboardEvents;
        break;
      case 'projects':
        content = await renderProjectsView();
        initViewEvents = initProjectsEvents;
        break;
      case 'crm':
      case 'pipeline':
        content = await renderPipelineView();
        initViewEvents = initPipelineEvents;
        break;
      case 'email-marketing':
        content = await renderEmailMarketingView();
        initViewEvents = initEmailMarketingEvents;
        break;
      case 'resources':
        content = await renderResourcesView();
        initViewEvents = initResourcesEvents;
        break;
      case 'rates':
        content = await renderRatesView();
        initViewEvents = initRatesEvents;
        break;
      case 'finance':
        content = await renderFinanceView();
        initViewEvents = initFinanceEvents;
        break;
      case 'knowledge':
        content = await renderKnowledgeView();
        initViewEvents = initKnowledgeEvents;
        break;
      case 'settings':
        content = await renderSettingsView();
        initViewEvents = initSettingsEvents;
        break;
      default:
        content = await renderDashboardView();
        initViewEvents = initDashboardEvents;
        break;
    }

    app.innerHTML = renderLayout(content, route);
    initLayoutEvents();
    initViewEvents();
  } catch (err) {
    console.error(`Error al cargar la ruta [${route}]:`, err);
    app.innerHTML = renderLayout(`
      <div class="p-8 max-w-lg mx-auto bg-surface border border-red-200 rounded-lg text-center space-y-3 shadow-sm my-12">
        <div class="w-10 h-10 rounded-full bg-red-50 text-red-600 flex items-center justify-center mx-auto text-lg">⚠️</div>
        <h2 class="text-sm font-bold text-text-primary">Error al cargar la vista</h2>
        <p class="text-xs text-text-secondary">${err.message || 'Ocurrió un error inesperado al inicializar la pantalla.'}</p>
        <div class="pt-2">
          <button onclick="window.location.reload()" class="px-4 py-2 text-xs font-semibold rounded bg-primary text-white hover:bg-primary-hover shadow-sm">
            Recargar Página
          </button>
        </div>
      </div>
    `, route);
    initLayoutEvents();
  }
}

